import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["classNameContainer", "classNameNestedCheckboxGroups", "classNameSearchFieldWrapper"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cn from 'clsx';
import { memoWithDisplayName } from '../../../helpers/memoWithDisplayName';
import { NestedCheckboxGroupsDesktop } from '../../NestedCheckboxGroups';
import { SearchField } from '../../SearchField';
import { useSearchValue } from '../hooks/useSearchValue';
import styles from './NestedCheckboxGroupsWithSearchDesktop.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NestedCheckboxGroupsWithSearchDesktop = memoWithDisplayName(function (props) {
  var classNameContainer = props.classNameContainer,
      classNameNestedCheckboxGroups = props.classNameNestedCheckboxGroups,
      classNameSearchFieldWrapper = props.classNameSearchFieldWrapper,
      restProps = _objectWithoutProperties(props, _excluded);

  var _useSearchValue = useSearchValue(),
      _useSearchValue2 = _slicedToArray(_useSearchValue, 2),
      searchValue = _useSearchValue2[0],
      handleSearchFieldChange = _useSearchValue2[1];

  return /*#__PURE__*/_jsxs("div", {
    className: classNameContainer,
    children: [/*#__PURE__*/_jsx("div", {
      className: cn(styles['search-field-wrapper'], classNameSearchFieldWrapper),
      children: /*#__PURE__*/_jsx(SearchField, {
        value: searchValue,
        onChange: handleSearchFieldChange
      })
    }), /*#__PURE__*/_jsx("div", {
      className: cn(styles['nested-checkbox-group-wrapper'], classNameNestedCheckboxGroups),
      children: /*#__PURE__*/_jsx(NestedCheckboxGroupsDesktop, _objectSpread({
        searchValue: searchValue
      }, restProps))
    })]
  });
}, 'NestedCheckboxGroupsWithSearchDesktop');